import { Input, Select } from 'antd';
import { useFieldDefaults } from './defaults';
import type { StringField } from './types';

/**
 * When Institution structure has grades configured, this is a Select over
 * that list. When it hasn't (first-boot tenants), it degrades to a free-text
 * Input so the form is still usable. The switch happens inside the field —
 * the form does not need a conditional.
 */
export function GradeField({ value, onChange, onBlur, ...rest }: StringField) {
  const defaults = useFieldDefaults();
  const options = defaults.grade?.options;

  if (!options || options.length === 0) {
    return (
      <Input
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onBlur={onBlur}
        placeholder={rest.placeholder ?? '9'}
        {...rest}
      />
    );
  }

  return (
    <Select
      value={value || undefined}
      onChange={(v) => onChange?.(v)}
      options={options as unknown as { value: string; label: string }[]}
      placeholder={rest.placeholder ?? 'Pick a grade'}
      allowClear
      disabled={rest.disabled}
      autoFocus={rest.autoFocus}
      status={rest.status}
      id={rest.id}
    />
  );
}
